import contactUs from '../../assets/common/contactUs.png';
import './contactSection.scss';
import {requestDemoEmail} from '../../utils/requestDemoEmail';

const ContactSection = () => {
    return (
        <>
        <div className="section_content middle">
        <div className="main_section_title header_2">
            Let's get in touch
        </div>
        <div className="text">
            Contact us to learn how FutureScape can transform how your 
            organization makes its toughest decisions.
        </div>
        <div>
            <button className="section_btn main text" onClick={requestDemoEmail}>Request Demo</button>
        </div>
        </div>
        <div className="contactUs_img">
            <img src={contactUs} alt=""></img>
        </div>
        </>
    )
}

export default ContactSection;